'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const LocationDropDown = require('../../../../shared/_layouts/_templates/_includes/engines/location-dropdown.jsx')
const TimeSelect = require('./times-dropdown.jsx')
const SearchButton = require('./searchButton.jsx')
const EngineHelper = require('../../../../shared/_layouts/_templates/_includes/engines/engineHelper.js')
const DateHelper = require('../../../../_plugins/lib/dateHelper.js')
const HiddenInputs = require('../../../../shared/_layouts/_templates/_includes/engines/hiddenInputs.jsx')
const Helpers = require('../../../../_plugins/lib/helpers.js')
const { string, object } = PropTypes

const ParkingEngine = createReactClass({
  mixins: [EngineHelper, Helpers],

  propTypes: {
    Location: string,
    domainSettings: object,
    formSettings: object,
    ArrivalDate: PropTypes.instanceOf(Date),
    DepartDate: PropTypes.instanceOf(Date),
    engineSearchField: string,
    hiddenLocation: string,
    agentData: object,
    agentSettings: object,
    selected: string,
    locations: object,
    pageData: object
  },

  getInitialState () {
    return {
      hiddenInputs: {}
    }
  },

  getDefaultProps () {
    return {
      hiddenLocation: '',
      engineSearchField: '',
      ArrivalDate: DateHelper.alterDateByNumberOfDays(new Date(), 1),
      DepartDate: DateHelper.alterDateByNumberOfDays(new Date(), 8),
      selected: 'cp'
    }
  },

  componentDidMount () {
    this.getHiddenInputs()
  },

  render () {
    const {
      Location,
      pageData: { pageName },
      domainSettings,
      ArrivalDate,
      DepartDate,
      engineSearchField,
      hiddenLocation,
      agentData,
      selected,
      formSettings,
      locations
    } = this.props
    const pagesName = pageName !== 'index' ? pageName + '.html' : ''
    const { hiddenInputs } = this.state
    const { agent, typeRID, groupCode } = agentData
    const arrivalDate = DateHelper.formatDateToDMY(ArrivalDate)
    const departDate = DateHelper.formatDateToDMY(DepartDate)
    const arrivalDateFormatted = DateHelper.formatDateToDddMMyy(ArrivalDate)
    const departDateFormatted = DateHelper.formatDateToDddMMyy(DepartDate)
    const activeClass = classNames({
      'hidden': selected !== 'cp',
      'hiddenLocation': hiddenLocation
    })
    const defaultInputs = {
      agentgroup: groupCode,
      channel: typeRID,
      agent: agent,
      product: 'cp',
      selectProduct: 'cp',
      request: '1',
      Referer: 'http://' + domainSettings.domain + '/' + pagesName,
      domain: domainSettings.domain,
      lang: 'en',
      rule_set: formSettings.ruleset
    }

    return (
      <div className={activeClass}>
        <form id='parkingEngine' acceptCharset='UTF-8' action={formSettings.parkingAction} className='panel panel-default' method={formSettings.method}>

          <div className='panel-body'>
            <div className='row'>

              { !hiddenLocation
                ? <div className='form-group airport'>
                  <label>Flying from</label>
                  <LocationDropDown activeLocation={Location || formSettings.defaultParkingLocation} locations={locations.carParking} onSelect={this.locationSelected} />
                </div>
              : <input name='Location' type='hidden' className='l' value={hiddenLocation} data-track-name='location' />
              }

              <div className='form-group date'>
                <label>Parking from</label>
                <input className='form-control alternateDA hxtrack' defaultValue={arrivalDateFormatted} readOnly />
                <input className='dA' name='ArrivalDate' defaultValue={arrivalDate} type='hidden' />
                <div />
              </div>

              <div className='form-group time'>
                <label className='sr-only'>Parking time</label>
                <TimeSelect name='ArrivalTime' activeTime={formSettings.defaultArrivalTime} pagename={pageName} />
              </div>

              <div className='form-group date'>
                <label className='hidden-xs hidden-sm hidden-md'>Returning to collect car</label>
                <label className='hidden visible-xs-inline-block visible-sm-inline-block visible-md-inline-block'>Collect car</label>
                <input className='form-control alternateDD hxtrack' defaultValue={departDateFormatted} readOnly />
                <input className='dD' name='DepartDate' defaultValue={departDate} type='hidden' />
                <div />
              </div>

              <div className='form-group time'>
                <label className='sr-only'>Parking time</label>
                <TimeSelect name='DepartTime' activeTime={formSettings.defaultDepartTime} pagename={pageName} />
              </div>

              <SearchButton />
            </div>
          </div>

          <HiddenInputs inputs={defaultInputs} />
          { engineSearchField && (
            <input name='search' type='hidden' value={engineSearchField} />
          )}
          <HiddenInputs inputs={hiddenInputs} />
        </form>
      </div>
    )
  }
})

module.exports = ParkingEngine



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/engine-horizontal/parking-engine.jsx